import React from "react";
import { withFormsy } from "formsy-react";

import connect from "../../../i18n/connect";
import FormsyBase from "./FormsyBase";
import Checkbox from "../../Checkbox/Checkbox";

@connect()
@withFormsy
class FormsyComposedNewCheckbox extends FormsyBase {
  render() {
    const {
      label,
      value,
      errorMessage,
      translate,
      translateData,
      className,
      labelClassName,
      indeterminate,
      expands,
      expandedLabel,
      required
    } = this.props;

    const showError = this.showError();

    return (
      <Checkbox
        label={translate(label, translateData)}
        expandedLabel={
          expandedLabel ? translate(expandedLabel, translateData) : undefined
        }
        expands={expands}
        moreLabel={expands ? translate("more") : undefined}
        checked={!!value}
        indeterminate={indeterminate}
        onClick={() => this.handleChange(!value)}
        errorMessage={showError ? translate(errorMessage) : null}
        className={className}
        labelClassName={labelClassName}
        required={required}
      />
    );
  }
}

export default FormsyComposedNewCheckbox;
